import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
// import Highcharts from './../components/Highcharts';
// import MyJourneyList from './MyJourneyLists';
const $=window.$;

class MyJourneyDemo extends Component {
	constructor(props) {
		super(props);
        this.state={};
				this.getLrinfo=this.getLrinfo.bind(this);

	}
	getTabs(){
	           window.$('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });

    }
	
	fnChangetabs(divClass){
		
		$("."+divClass).slideToggle();
	}
	componentDidMount() {
	
	 	this.getTabs();
	}

	getLrinfo(type,lr_id,dlr_id){
					// alert(type);
					this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
			const {Webview} = this.props;
		return (

		 <section id="contentsection" className="contentarea myjourneyDemo">
          <div className="inner-title-bg journey-tit-bg">
							<h1> <span> <img src={process.env.PUBLIC_URL+'/images/img-myjourney.jpg'} align="absmiddle" alt="" border="0" /> </span> My Journey<br />
								<span className="subtitle">A quick view of my progress in the program</span></h1>
						</div>
						<div className="main-inner">
							
							<div className="border-box">
								
								<section id="semana-scroll-inner" className="scroll1">
									
									
									<section className="viewport">
										<section className="overview">
											<div className="inner-content">
												
											<div className="myjourney-chart">
												<div className="myjourneychart-left"> <img src={process.env.PUBLIC_URL+'/images/my-jurney_1.jpg'} alt="" title=""  style={{'width':'auto', 'max-width': '100%', 'margin': '10px auto 0' }} />
													<div className="list-myj gr-bg">
														<ul>
															<li>Avg time spent by all per LR: <span className="org">00 hrs 38 min</span></li>
															<li>Average time I spent per LR: <span className="grn">00 hrs 45 min</span></li>
															<li>Total time spent in LRs: <span className="grn">04 hrs 30 min</span></li>
														</ul>
													</div>
												</div>
												<div className="myjourneychart-right"> <img src={process.env.PUBLIC_URL+'/images/my-jurney_2.jpg'} alt="" title=""   style={{'width':'auto', 'max-width': '100%', 'margin': '10px auto 0' }} />
													<div className="list-myj gr-bg">
														<ul>
															<li>Avg time spent by all per DLR: <span className="org">01 hrs 40 min</span></li>
															<li>Average time I spent per DLR: <span className="grn">01 hrs 45 min</span></li>
															<li>Total time spent in DLRs: <span className="grn">14 hrs 00 min</span></li>
														</ul>
													</div>
												</div>
											</div>

												
												<div className="myourney-inner">
													<div id="parentHorizontalTab">
														<ul className="resp-tabs-list hor_1 hr-22">
															<li>LRs Room-wise</li>
															<li>LRs Module-wise </li>
															<li>DLRs Room-wise</li>
															<li>DLRs Module-wise</li>
														</ul>
														<div className="resp-tabs-container hor_1">
															
															<div className="tab-content">
																<div className="abbrevation">
																	<ul>
																		
																		<li><strong>PS</strong> - Performance Score</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" title="" /> - Completed</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-notcompleted.png'} alt="" title="" /> - In Progress</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" title="" /> - Yet to start</li>
																	</ul>
																</div>
																<div className="myjourney-tabhead sixcolumns">
																	<div className="headrow">
																		<div className="col">Rooms</div>
																		<div className="col col2">Room Name</div>
																		<div className="col col3">Module Name</div>
																		
																		<div className="col col4">PS</div>
																		<div className="col col5">Status</div>
																	</div>
																</div>
																<div className="tablehide" id="para" onClick={(e)=>this.fnChangetabs("tablejourney1")}> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />LRs 1 to 10</div>
																<div className="tablejourney1  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '22.2%'}}>MBA Common</td>
																					
																					<td style={{width: '20.4%'}}>--</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '22.2%'}}>MBA Common</td>
																					
																					<td style={{width: '20.4%'}}><strong>63%</strong> (34/54)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '22.2%'}}>MBA Common</td>
																					
																					<td style={{width: '20.4%'}}><strong>18.2%</strong>(2/11)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR4</a></td>
																					<td style={{width: '34.2%'}}>Assessment on Principles of Management Ch 1 to 4</td>
																					<td style={{width: '22.2%'}}>Principles of Management</td>
																					
																					<td style={{width: '20.4%'}}><strong>64.3%</strong>(9/14)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																{/* <div className="tablehide" id="para" onClick={(e)=>this.fnChangetabs("tablejourney2")}> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />LRs 2 to 10</div>
																<div className="tablejourney2  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR5</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '22.2%'}}>MBA Common</td>
																					
																					<td style={{width: '20.4%'}}>--</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR6</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '22.2%'}}>MBA Common</td>
																					
																					<td style={{width: '20.4%'}}><strong>63% </strong>(34/54)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR7</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '22.2%'}}>MBA Common</td>
																					
																					<td style={{width: '20.4%'}}><strong>18.2%</strong>(2/11)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR8</a></td>
																					<td style={{width: '34.2%'}}>Assessment on Principles of MAnagement Ch 1 to 4</td>
																					<td style={{width: '22.2%'}}>Principles of MAnagement</td>
																					
																					<td style={{width: '20.4%'}}><strong>64.3%</strong>(9/14)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div> */}
															</div>
															
															<div className="tab-content">
																<div className="abbrevation">
																	<ul>
																		
																		<li><strong>PS</strong> - Performance Score</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" title="" /> - Completed</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-notcompleted.png'} alt="" title="" /> - In Progress</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" title="" /> - Yet to start</li>
																	</ul>
																</div>
																<div className="myjourney-tabhead sixcolumns">
																	<div className="headrow">
																		<div className="col">Rooms</div>
																		<div className="col col2">Room Name</div>
																		
																		
																		<div className="col col2">PS</div>
																		<div className="col col4">Status</div>
																	</div>
																</div>
																<div className="tablehide" id="para" onClick={(e)=>this.fnChangetabs("tablejourney3")}> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />MBA Common</div>
																<div className="tablejourney3  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2%</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment 1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Principles of Management</div>
																<div className="tablejourney4  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Managerial Communication</div>
																<div className="tablejourney5  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />HR Management</div>
																<div className="tablejourney6  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Marketing Management</div>
																<div className="tablejourney7  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Financial Management</div>
																<div className="tablejourney8  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Business Mathematics and Statistics</div>
																<div className="tablejourney9  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Production and Materials Management</div>
																<div className="tablejourney10  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Advertising Management</div>
																<div className="tablejourney11  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">LR1</a></td>
																					<td style={{width: '34.2%'}}>Orientation</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">LR2</a></td>
																					<td style={{width: '34.2%'}}>Understanding Business</td>
																					<td style={{width: '34%'}}><strong>63%</strong>(34/54)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR3</a></td>
																					<td style={{width: '34.2%'}}>Useful Business Terms</td>
																					<td style={{width: '34%'}}><strong>18.2</strong>(2/11)</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">LR20</a></td>
																					<td style={{width: '34.2%'}}>Making Distinctions in Communication</td>
																					<td style={{width: '34%'}}>-</td>
																					
																					
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																					
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">LR37</a></td>
																					<td style={{width: '34.2%'}}>Assignment1</td>
																					<td style={{width: '34%'}}>-</td>
																					
																				
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
															</div>
															
															<div className="tab-content"  >
																<div className="abbrevation">
																	<ul>
																		
																		<li><strong>PS</strong> - Performance Score</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" title="" /> - Completed</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-notcompleted.png'} alt="" title="" /> - In Progress</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" title="" /> - Yet to start</li>
																	</ul>
																</div>
																<div className="myjourney-tabhead sixcolumns">
																	<div className="headrow">
																		<div className="col">DLR ID</div>
																		<div className="col col2">DLR Name</div>
																		<div className="col col3">Module Name</div>
																		
																		<div className="col col4">PS</div>
																		<div className="col col5">Status</div>
																	</div>
																</div>
																<div className="tableshow4 divv" id="div1">
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table hr-t-bg">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T5">PoM1-4</a></td>
																					<td style={{width: '34%'}}>Principles of Management(1-4)</td>
																					<td style={{width: '22.5%'}}>Principles of Management</td>
																					
																					<td style={{width: '20.1%'}}>82.4%(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T4">MC1-4</a></td>
																					<td style={{width: '34%'}}>Managerial Communication(1-4)</td>
																					<td style={{width: '22.5%'}}>Managerial Communication</td>
																					
																					<td style={{width: '20.1%'}}>37.5%(6/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T3">MM1-4</a></td>
																					<td style={{width: '34%'}}>Marketing Management(1-4)</td>
																					<td style={{width: '22.5%'}}>Marketing Management</td>
																					
																					<td style={{width: '20.1%'}}>42.9%(12/28)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '11%'}}><a href="#" title="Go to DLR QA-T2">HRM1-4</a></td>
																					<td style={{width: '34%'}}>HR Management(1-4)</td>
																					<td style={{width: '22.5%'}}>HR Management</td>
																					
																					<td style={{width: '20.1%'}}>34.8%(8/23)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																		</tbody>
																		</table>
																	</div>
																</div>
															</div>
															<div className="tab-content">
																<div className="abbrevation">
																	<ul>
																		
																		<li><strong>PS</strong> - Performance Score</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" title="" /> - Completed</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/status-notcompleted.png'} alt="" title="" /> - In Progress</li>
																		<li><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" title="" /> - Yet to start</li>
																	</ul>
																</div>
																<div className="myjourney-tabhead fivecolumns">
																	<div className="headrow">
																		<div className="col">Modules</div>
																		<div className="col col2">DLR Name</div>
																		
																		<div className="col col4">PS</div>
																		<div className="col col5">Status</div>
																	</div>
																</div>
																<div className="tablehide" id="para" onClick={(e)=>this.fnChangetabs("tablejourney21")}> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Principles of Management</div>
																<div className="tablejourney21  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">PoM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">PM1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Managerial Communication</div>
																<div className="tablejourney22  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />HR Management</div>
																<div className="tablejourney23  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Marketing Management</div>
																<div className="tablejourney24  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Financial Management</div>
																<div className="tablejourney25  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Business Mathematics and Statistics</div>
																<div className="tablejourney26  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Production and Materials Management</div>
																<div className="tablejourney27  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Advertising Management</div>
																<div className="tablejourney28  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
																<div className="tablehide" id="para"> <img title="" alt="" src={process.env.PUBLIC_URL+'/images/downarrow.png'} />Exam Preparation</div>
																<div className="tablejourney29  tabcls divv tableshow" id="div1" style={{display:'none'}}>
																	<div className="my-journey-table-content fivecolumns">
																		<table cellPadding="0" cellSpacing="0" style={{width:'100%'}} className="myjourney-table">
																			
																			<tbody>
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T5">poM1-4</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-4)</td>
																					
																					
																					<td style={{width: '20.4%'}}><strong>82.4%</strong>(28/34)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T4">PoM512</a></td>
																					<td style={{width: '33%'}}>Principles of Management(5-12)</td>
																					
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="oddbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T3">Po1324</a></td>
																					<td style={{width: '33%'}}>Principles of Management(13-24)</td>
																				
																					
																					<td style={{width: '20.4%'}}>-</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/start-small.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																				
																				<tr className="evenbg">
																					<td style={{width: '13%'}}><a href="#" title="Go to DLR QA-T2">Pm1-12</a></td>
																					<td style={{width: '33%'}}>Principles of Management(1-12)</td>
																				
																					
																					<td style={{width: '20.4%'}}><strong>25%</strong>(4/16)</td>
																					<td style={{}}><img src={process.env.PUBLIC_URL+'/images/status-completed.png'} alt="" className="tick" width="15" height="15" border="0" /></td>
																				</tr>
																				
																			</tbody>
																		</table>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											
										</section>
									</section>
								</section>
								
							</div>
							
						</div>
        </section>

			);

		}
}

export default MyJourneyDemo;



// WEBPACK FOOTER //
// ./src/learning_records/MyJourneyDemo.js